/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {ModuleWithProviders, NgModule} from '@angular/core';
import { ChipModule } from 'primeng/chip';
import {CommonModule} from '@angular/common';
import {PlacesService} from './places.service';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import { LegacyChipsComponent } from '@well/infra/legacy-primeng-components';
import {PlacesPickerComponent} from './places-picker/places-picker.component';
import {ButtonModule} from "primeng/button";

@NgModule({
  imports: [ChipModule, 
    CommonModule,
    RouterModule,
    FormsModule,
    ButtonModule,
    LegacyChipsComponent],
  declarations: [PlacesPickerComponent],
  exports: [PlacesPickerComponent]
})
export class PlacesModule {
  static forRoot(): ModuleWithProviders<PlacesModule> {
    return {
      ngModule: PlacesModule,
      providers: [
        PlacesService
      ]
    };
  }
}
